import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-appointment-requests',
  templateUrl: './appointment-requests.component.html',
  styleUrls: ['./appointment-requests.component.scss']
})
export class AppointmentRequestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
